import React from 'react';
import Link from 'next/link';
import Logo from '../../Logo/Logo';
import Styles from '../Styles.module.scss';
import PropTypes from 'prop-types';

// export default class LeadgenFormTitle extends React.Component {
//   static propTypes = {
//     className: PropTypes.string,
//     children: PropTypes.node,
//   };

//   render() {
//     const { children } = this.props;
//     return (
//       <div className={classNames(Styles.leadgenFormTitle, Styles.leadgenFormTitleCenter)}>
//         <Link title='' to='/'>
//           <Logo className={Styles.formLogo} type={Logo.Type.BLACK} />
//         </Link>
//         <h3 className={classNames(Styles.typeFormheadline, Styles.typeStandard)}>{children}</h3>
//       </div>
//     );
//   }
// }

const Title = ({ title, subtitle }) => {
  return (
    <div className={Styles.header}>
      <Link href='/'>
        <a>
          <Logo className={Styles.formLogo} type={Logo.Type.BLACK} />
        </a>
      </Link>
      {title ? <h3 className={Styles.title}>{title}</h3> : ''}
      {subtitle ? <p className={Styles.subtitle}>{subtitle}</p> : ''}
    </div>
  );
};

Title.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default Title;
